import React from 'react';
import ReactDOM from "react-dom";
import Invoice from './invoice';
import UserProfile from './userProfile';
import CustomerProfile from './customerProfile';

export default class Customer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            isSubmitting: false,
            companyID: null,
            customer: null
        };
    }

    customerCheck() {
        var userID = UserProfile.getUserID();
        var uCompanyID = UserProfile.getCompanyID();
        var name = document.getElementById("name").value;
        var zipcode = document.getElementById("zipcode").value;
        var city = document.getElementById("city").value;
        var address = document.getElementById("address").value;
        var phone = document.getElementById("phone").value;
        var taxnumber = document.getElementById("taxnumber").value;
        var iban = document.getElementById("iban").value;
        var companyID = document.getElementById("companyID").value;
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        const data = { event: 'c-write', userID: userID, uCompanyID: uCompanyID, name: name, zipcode: zipcode, city: city, address: address, phone: phone, taxnumber: taxnumber, iban: iban, companyID: companyID };
        if (name === '' || zipcode === '' || city === '' || address === '') {
            this.state.value = "Valamelyik kötelező mező nem lett kitöltve!";
            this.customerRecording();
        } else {
            fetch(url, {
                method: "POST",
                body: new URLSearchParams(data),
                headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
            })
                .then(res => {
                    this.isSubmitting = false;
                    return res.json();
                })
                .then(
                    (result) => {
                        this.isLoaded = true;
                        this.companyID = null;
                        this.history = result;
                        this.clientsGet();
                    },
                    (error) => {
                        this.isLoaded = true;
                        this.errorn = error;
                    }
                )
        }
    }

    customerRecording = () => {
        new Invoice().customerRecording();
    };

    clientsGet() {
        new Invoice().clientsGet();
    }

    customerDataGet(companyID) {
        this.companyID = companyID;
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'client-get', companyID: companyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    //console.log(result);
                    CustomerProfile.setCompanyID(companyID);
                    CustomerProfile.setCustomer(result);
                },
                (error) => {
                    this.error = error;
                }
            )
        return this.customer;
    }

    customerGetInfo(companyID) {
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'client-get', companyID: companyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.customer = result;
                    //console.log(result);
                    CustomerProfile.setCompanyID(companyID);
                    CustomerProfile.setCustomer(result);
                    this.customerGet(result);
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    customerGet(customer) {
        const res = this.customerForm(customer);
        ReactDOM.render(res, document.getElementById('invoiceBody')
        );
    }

    customerDelete() {
        var companyID = CustomerProfile.getCompanyID();
        var uCompanyID = UserProfile.getCompanyID();
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        var data = { event: 'c-del', del: companyID, uCompanyID: uCompanyID };
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.customer = result;
                    new Invoice().clientsGet();
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
    }

    customerForm(customer) {
        var companyID = CustomerProfile.getCompanyID();
        return (
            <div>
                <h1>Ügyfél módosítása</h1>
                <div className='row'>
                    <i className='cDel' onClick={() => this.customerDelete()}>{'Ügyfél törlése'}</i>
                </div>
                <div className='row'>
                    <input id='name' type='text' placeholder=' Ügyfél neve' defaultValue={customer.name} />
                </div>
                <div className='row'>
                    <input id='zipcode' type='text' placeholder=' IRSZ' defaultValue={customer.zipCode} />
                </div>
                <div className='row'>
                    <input id='city' type='text' placeholder=' Város' defaultValue={customer.city} />
                </div>
                <div className='row'>
                    <input id='address' type='text' placeholder=' Cím' defaultValue={customer.address} />
                </div>
                <div className='row'>
                    <input id='phone' type='text' placeholder=' Telefon' defaultValue={customer.phone} />
                </div>
                <div className='row'>
                    <input id='taxnumber' type='text' placeholder=' Adószám' defaultValue={customer.taxNumber} />
                </div>
                <div className='row'>
                    <input id='iban' type='text' placeholder=' Bankszámla száma' defaultValue={customer.iban} />
                </div>
                <div className='row'>
                    <input id='companyID' type='hidden' value={companyID} />
                </div>
                <div>
                    <button className="push" onClick={() => this.customerCheck()}>
                        {'Mentés'}
                    </button>
                </div>
            </div>
        );
    }

    customerSearchData() {
        var word = document.getElementById('word').value;
        var uCompanyID = UserProfile.getCompanyID();
        var data = { event: 'company-search', word: word, uCompanyID: uCompanyID }
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.setState({ isSubmitting: false });
                return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        history: result
                    });
                    //console.log(this.isLoaded);
                    //console.log(result);
                    this.customerSearchShow(result, word);
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    customerSearchShow(cData, word) {
        if (document.getElementById('search').style.display === 'none' && word.length > 0) {
            var customerList = cData.map((customer) => <li onClick={() => this.customerSearch(customer.companyID)} key={customer.companyID}>{customer.name}</li>);
            document.getElementById('search').style.display = 'block';
            ReactDOM.render(
                <ul>{customerList}</ul>, document.getElementById('search')
            );
        } else {
            document.getElementById('search').style.display = 'none';
        }
    }

    customerSearch(id) {
        var data = { event: 'client-get', companyID: id }
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.setState({ isSubmitting: false });
                return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        history: result
                    });
                    //console.log(this.isLoaded);
                    this.customerSearchAdd(result);
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    customerSearchAdd(customer) {
        document.getElementById('name').value = customer.name;
        document.getElementById('zipcode').value = customer.zipCode;
        document.getElementById('city').value = customer.city;
        document.getElementById('address').value = customer.address;
        document.getElementById('phone').value = customer.phone;
        document.getElementById('taxnumber').value = customer.taxNumber;
        //document.getElementById('iban').value = customer.iban;
        document.getElementById('search').style.display = 'none';
    }

    render() {
        return (
            <div>
                <h1>Ügyfél rögzítése</h1>
                {this.state.value}
                <div className='row'>
                    <input id='word' onKeyDown={() => this.customerSearchData()} type='text' placeholder=' Cég kereső' />
                </div>
                <div id='search'></div>
                <div className='row'>
                    <input id='name' type='text' placeholder=' Ügyfél neve' />
                </div>
                <div className='row'>
                    <input id='zipcode' type='text' placeholder=' IRSZ' />
                </div>
                <div className='row'>
                    <input id='city' type='text' placeholder=' Város' />
                </div>
                <div className='row'>
                    <input id='address' type='text' placeholder=' Cím' />
                </div>
                <div className='row'>
                    <input id='phone' type='text' placeholder=' Telefon' />
                </div>
                <div className='row'>
                    <input id='taxnumber' type='text' placeholder=' Adószám' />
                </div>
                <div className='row'>
                    <input id='iban' type='text' placeholder=' Bankszámla száma' />
                </div>
                <div className='row'>
                    <input id='companyID' type='hidden' value='null' />
                </div>
                <div>
                    <button className='push' onClick={() => this.customerCheck()}>
                        {this.props.value}
                    </button>
                </div>
            </div>
        );
    }

}